export const userCitySignUp = `
query UserCitySignUp {
  managementStats {
    user {
      citySignUp {
        name
        count
      }
    }
  }
}
`